/** Exact path or nested under a nav item base path (e.g. `/vendors/new`). */
export function isNavItemActive(pathname: string, to: string): boolean {
  return pathname === to || pathname.startsWith(`${to}/`);
}
